
/* @ngInject */
export default class CardFlowService {
  constructor($q, $rootScope) {
    this.$rootScope = $rootScope;
    this.$q = $q;
  }
  load(items, count, start) {
    this.deferred = this.$q.defer();
    this.items = items;
    this.itemCount = count || this.items.length;
    this.startCount = start || 0;
    this.loadCount = 0;
    for (let i = this.startCount; i < (this.startCount + this.itemCount); i += 1) {
      this._loadImageLocation(this.items[i].thumbnail);
    }
    return this.deferred.promise;
  }
  _loadImageLocation(item) {
    let loader = this;
    angular.element(new Image())
      .on('load', (event) => {
        this.$rootScope.$apply(() => {
          loader._handleImageLoad(event.target.src);
          loader = null;
          event = null;
        });
      })
      .on('error', (event) => {
        this.$rootScope.$apply(() => {
          loader._handleImageLoad(event.target.src);
          loader = null;
          event = null;
        });
      })
      .prop('src', item);
  }
  _handleImageLoad() {
    this.loadCount += 1;
    if (this.loadCount === this.itemCount) {
      this.deferred.resolve(this.items);
    }
  }
}

